<template>
  <div class="overflow-y-auto bg-primary-bg-color">
    <div>
      <router-view />
      <LoadingOverlay />
    </div>
    <Modal />
    <ChatPopup />
    <ToastContainer />
  </div>
</template>

<script setup>
import Modal from "@/components/UI/Modal/Modal.vue";
import LoadingOverlay from "./components/UI/Loading/LoadingOverlay.vue";
import ChatPopup from "./components/Chat/ChatPopup.vue";
import ToastContainer from "./components/UI/Toast/ToastContainer.vue";
</script>
